'use strict';

/**
 * Заглушка вместо клиентской выдачи по самолётам для маршрутов из/в РФ.
 * Тип определяется бэкендом (feature-флаг FEATURE_RU_ROUTES_STUB):
 *  - 'ru_eu'       — маршрут из/в РФ в страну ЕС;
 *  - 'ru_domestic' — маршрут РФ↔РФ или РФ↔страны вне ЕС.
 *
 * На сайте Travel показываем только заголовок, без контактов.
 */

// Переводы содержат <br> для жёстких переносов из вёрстки — рендерим их как <br/>.
// Маркер <br> (а не \n) — потому что window.messagesReact вкладывается в одинарные
// JS-кавычки через JSON.parse('...'), и любой LF ломает парсинг.
function withLineBreaks(text) {
    return text.split(/<br\s*\/?>/i).map((line, i, arr) => (
        <React.Fragment key={i}>
            {line}
            {i < arr.length - 1 && <br />}
        </React.Fragment>
    ));
}

export default function SearchRouteStub({ type, contacts = {} }) {
    const isTravel = !!(window.Site && window.Site.isTravel);

    if (isTravel) {
        const title = type === 'ru_eu'
            ? tMsg2('searchStub.travel.ruEu')
            : tMsg2('searchStub.travel.ruDomestic');
        return <div className="el-empty el-empty--route-stub">
            <h3>{withLineBreaks(title)}</h3>
        </div>;
    }

    const { phone_link, whatsapp, telegram, max } = contacts;
    const title = type === 'ru_eu'
        ? tMsg2('searchStub.ruEu.title')
        : tMsg2('searchStub.ruDomestic');
    const note = type === 'ru_eu' ? tMsg2('searchStub.ruEu.note') : '';

    return <div className="el-empty el-empty--route-stub">
        <h3>{withLineBreaks(title)}</h3>
        {note && !note.startsWith('.') && <p>{withLineBreaks(note)}</p>}
        <p>{tMsg2('searchStub.cta')}</p>
        <div className="el-empty__social">
            {phone_link && <a href={phone_link}><i className="e-phone"></i></a>}
            {telegram && <a href={telegram} target="_blank" rel="noopener noreferrer"><i className="e-tg"></i></a>}
            {whatsapp && <a href={whatsapp} target="_blank" rel="noopener noreferrer"><i className="e-wa"></i></a>}
            {max && <a href={max} target="_blank" rel="noopener noreferrer"><i className="e-max"></i></a>}
        </div>
    </div>;
}
